import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from '../../../../../../taboola-common-frontend-modules/i18n';
import { isSponsoredAccountAndDimension } from '../../../../../config/report-predicates/isSponsoredAccountAndDimension';
import { REPORT_PERMISSION } from '../../../../../config/reportPermissions';
import { TOP_RESULTS_TYPE } from '../../../../../constants';
import AUDIENCE_DATA_TYPE_MODE from '../../../../../constants/audienceDataTypeMode';
import { getIsMarketplaceAudiencesBundlingEnabled } from '../../../../../services/utils/audiences';
import { BULK_ACTION } from '../../../components/BulkActionToolbar/bulkAction';
import * as FIELDS from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import { AUDIENCE_INSIGHTS_REPORT_ID } from './audineceInsightsReportId';
import columnDefinitions from './columnDefinitions';
import { generateBulkActionsOnDuplicateHandler } from './generateBulkActionsOnDuplicateHandler';
import graph from './graph';
import { customColumns, defaultColumns } from './reportPresets';

export const audiencesInsightsReportConfig = {
    id: AUDIENCE_INSIGHTS_REPORT_ID,
    label: 'Audiences Exploration',
    accountConfigurations: {
        [FEATURE_FLAGS.ONLY_PERFORMANCE_REPORTS]: 'false',
        [FEATURE_FLAGS.CAN_EDIT_CAMPAIGN_USER_SEGMENTS]: 'true',
    },
    permissions: [REPORT_PERMISSION.ADS_CONSOLE_AUDIENCE_REPORT],
    visibilityCondition: conf => {
        const {
            selectedAccount,
            configs: { selectedAccountConfig },
        } = conf;
        return (
            isSponsoredAccountAndDimension(conf) &&
            !getIsMarketplaceAudiencesBundlingEnabled(selectedAccountConfig, selectedAccount)
        );
    },
    module: CAMPAIGNS_MODULE,
    endpoint: 'campaign-report-by-audience-insights',
    graph,
    rowIdField: FIELDS.ID.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: [],
    isEmptyFooter: true,
    searchPlaceholderMsgId: 'app.reports.byAudience.search.placeholder',
    searchField: FIELDS.AUDIENCE_NAME.field,
    sortMap: {
        [FIELDS.CONVERSIONS.field]: 'cpaActionsNum',
        [FIELDS.CONVERSIONS_CLICKS.field]: 'cpaActionsNumFromClicks',
        [FIELDS.CONVERSIONS_VIEWS.field]: 'cpaActionsNumFromViews',
        [FIELDS.CVR.field]: 'cpaConversionRate',
        [FIELDS.AVERAGE_CPC.field]: 'cpc',
        [FIELDS.CVR_CLICKS.field]: 'cpaConversionRateClicks',
        [FIELDS.CVR_VIEWS.field]: 'cpaConversionRateViews',
    },
    bulkActions: [
        {
            key: BULK_ACTION.DUPLICATE,
            handler: generateBulkActionsOnDuplicateHandler,
            buttonContent: (
                <FormattedMessage
                    id="app.campaigns.reports.bulkAction.toolbar.duplicate.audience"
                    defaultMessage="Duplicate Campaign Using Audiences"
                />
            ),
        },
    ],
    filters: [
        {
            id: FILTER_TYPE.TOP_RESULTS,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS'],
        },
        {
            id: FILTER_TYPE.PARTNER_NAME,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS'],
        },
        {
            id: FILTER_TYPE.AUDIENCE_DATA_TYPE_MODE,
            permissions: ['ADS_CONSOLE_AUDIENCE_DATA_TYPE_FILTER'],
        },
    ],
    initialFilters: [
        {
            id: FILTER_TYPE.TOP_RESULTS,
            type: FILTER_TYPE.TOP_RESULTS,
            values: [{ value: TOP_RESULTS_TYPE.TOP200, label: 'Top 200', messageId: 'report.topResults.200' }],
            accountConfigurations: { [FEATURE_FLAGS.REPORT_AUTO_FILTERS]: 'true' },
        },
        {
            id: FILTER_TYPE.AUDIENCE_DATA_TYPE_MODE,
            type: FILTER_TYPE.AUDIENCE_DATA_TYPE_MODE,
            values: [
                {
                    value: AUDIENCE_DATA_TYPE_MODE.ALL,
                    label: 'All Audiences',
                    messageId: 'report.audienceDataTypeMode.ALL',
                },
            ],
            accountConfigurations: { [FEATURE_FLAGS.REPORT_AUTO_FILTERS]: 'true' },
        },
    ],
};

export default audiencesInsightsReportConfig;
